import React from "react";
import { usePublicCompany } from "../hooks/users/usePublicCompany";
import { Building2 } from "lucide-react";
import { cn } from "./utils";
import withTooltip from "@/hocs/withTooltip";

const getInitials = (name) => {
  if (!name) return "";

  const names = name.split(" ");

  if (names.length === 1) {
    return names[0].substring(0, 3) + "";
  }

  const initials = names.reduce((acc, name) => {
    if (name === "AB") return acc;
    return acc + name?.charAt?.(0);
  }, "");

  return initials;
};

const CompanyAvatar = ({
  companyId,
  companyName,
  bgIcon = (
    <Building2 strokeWidth={1} size={32} className="text-brand-600/50" />
  ),
  size = "md",
  className,
  onClick,
}) => {
  const { data: company } = usePublicCompany(companyId);
  const name = company?.name ?? companyName;
  const isCompact = size === "sm" || size === "xs";

  const imageUrl = company?.image?.thumbnail?.filename
    ? `https://app.invono.se/api/companies/public/images/${company.image.thumbnail.filename}-100?companyId=${companyId}`
    : null;

  return (
    <div
      className={cn(className, "aspect-square h-16 w-16", {
        "h-8 w-8": size === "sm",
        "h-6 w-6": size === "xs",
        "cursor-pointer": typeof onClick === "function",
      })}
      onClick={onClick}
    >
      {imageUrl ? (
        <div
          className={cn(
            "flex h-full w-full items-center justify-center overflow-hidden rounded-md bg-white",
            { "rounded-sm": size === "xs" },
          )}
        >
          <img src={imageUrl} />
        </div>
      ) : (
        <div
          className={cn(
            "bg-brand-700 text-brand-600/50 relative top-0 left-0 h-16 w-16 rounded-md",
            {
              "h-8 w-8": size === "sm",
              "h-6 w-6 overflow-hidden rounded-sm": size === "xs",
            },
          )}
        >
          {size !== "xs" && (
            <div
              className={cn(
                "absolute right-0 bottom-0 left-0 flex h-16 items-center justify-center",
                { "h-8": size === "sm" },
              )}
            >
              {bgIcon}
            </div>
          )}
          <div
            className={cn(
              "text-md text-brand-100 absolute top-0 left-0 flex h-16 w-16 items-center justify-center p-2 text-center leading-[12px] font-bold break-all",
              {
                "h-8 w-8": size === "sm",
                "h-6 w-6 p-0 text-[1rem] leading-none": size === "xs",
              },
            )}
          >
            {isCompact ? name?.charAt?.(0) : getInitials(name)}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTooltip()(CompanyAvatar);
